<div class="table-container" *ngIf="loggedUser">
    <div class="bluebox">
        <span class="title">{{"MANAGEMENT.MANAGEMENT_PAGE" | translate}}</span>
    </div>

    <div class="but-holder">
        <button (click)="logout()">{{"MANAGEMENT.LOGOUT" | translate}}</button>
    </div>
    <div class="global-container">
        <div class="hamburger-menu">
            <button [ngClass]="menuShow ? 'menu__show': 'menu__btn'" (click)="menuShow = !menuShow">
                <span></span>
            </button>


            <ul class="menu__box" [ngClass]="{'open__box': menuShow}">
                <li *ngIf="loggedUser !== undefined">
                    <button class="menu__item" (click)="initWhitelist()">{{"MANAGEMENT.WHITELIST" | translate}}</button>
                </li>
                <li *ngIf="loggedUser !== undefined && loggedUser.role === 'ROLE_ADMIN'">
                    <button class="menu__item" (click)="initProperties()">{{"MANAGEMENT.PROPERTIES" | translate}}</button>
                </li>
                <li *ngIf="loggedUser !== undefined && loggedUser.role === 'ROLE_ADMIN'">
                    <button class="menu__item" (click)="this.section='registry'">{{"MANAGEMENT.REGISTRY" | translate}}</button>
                </li>
                <li class="submenu" *ngIf="loggedUser !== undefined">
                    <div class="menu__item">
                        Services
                    </div>
                    <ul>
                        <li *ngIf="loggedUser !== undefined">
                            <button class="submenu__item"
                                (click)="initSingleService('Procedures'); menuShow=false; loadedData=false">{{"MANAGEMENT.SERVICE_TYPE.PROCEDURES" | translate}}</button>
                        </li>
                        <li *ngIf="loggedUser !== undefined">
                            <button class="submenu__item"
                                (click)="initSingleService('Requirements'); menuShow=false; loadedData=false">{{"MANAGEMENT.SERVICE_TYPE.REQUIREMENTS" | translate}}</button>
                        </li>
                        <li *ngIf="loggedUser !== undefined">
                            <button class="submenu__item"
                                (click)="initSingleService('PidServiceCatalog'); menuShow=false; loadedData=false">{{"MANAGEMENT.SERVICE_TYPE.PID_SERVICE_CATALOG" | translate}}</button>
                        </li>
                        <li *ngIf="loggedUser !== undefined">
                            <button class="submenu__item"
                                (click)="initSingleService('ProcedureRequirements'); menuShow=false; loadedData=false">{{"MANAGEMENT.SERVICE_TYPE.PROCEDURE_REQUIREMENTS" | translate}}</button>
                        </li>
                        <li *ngIf="loggedUser !== undefined">
                            <button class="submenu__item"
                                (click)="initSingleService('RequirementPidCatalog'); menuShow=false; loadedData=false">{{"MANAGEMENT.SERVICE_TYPE.REQUIREMENT_PID_CATALOG" | translate}}</button>
                        </li>
                    </ul>
                </li>

                <li *ngIf="loggedUser !== undefined">
                    <button class="menu__item" (click)="initTemplate()">{{"MANAGEMENT.TEMPLATES" | translate}}</button>
                </li>
            </ul>
        </div>
        <div *ngIf="section === 'whitelist' && loadedData" class="mat-elevation-z8 section">
            <mat-form-field class="filter">
                <mat-label>Filter</mat-label>
                <input matInput (keyup)="applyFilter($event)" placeholder="" #input>
            </mat-form-field>
            <table mat-table [dataSource]="dataSource" matSort aria-hidden="true">

                <ng-container matColumnDef="id">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> ID </th>
                    <td mat-cell *matCellDef="let row">
                        <div>{{row.id}}</div>
                    </td>
                </ng-container>

                <ng-container matColumnDef="url">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> Url </th>
                    <td mat-cell *matCellDef="let row">
                        <div *ngIf="!(row.actions && (row.actions === 'new' || row.actions === 'edit'))">{{row.url}}
                        </div>
                        <div *ngIf="row.actions && (row.actions === 'new' || row.actions === 'edit')"><input type="text"
                                [(ngModel)]="urlInput"></div>
                    </td>
                </ng-container>

                <ng-container matColumnDef="active">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> {{"MANAGEMENT.IS_ACTIVE" | translate}} </th>
                    <td mat-cell *matCellDef="let row">
                        <div *ngIf="!(row.actions && (row.actions === 'new' || row.actions === 'edit'))">{{row.active}}
                        </div>
                        <div *ngIf="row.actions && (row.actions === 'new' || row.actions === 'edit')">
                            <select [(ngModel)]="isActive">
                                <option value=true>True</option>
                                <option value=false>False</option>
                            </select>
                        </div>
                    </td>
                </ng-container>

                <ng-container matColumnDef="actions">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> {{"MANAGEMENT.ACTIONS" | translate}} </th>
                    <td mat-cell *matCellDef="let row">
                        <div *ngIf="!(row.actions && (row.actions === 'new' || row.actions === 'edit'))"><button
                                [disabled]="visibleInputs"
                                (click)="row.actions = 'edit'; visibleInputs = true; urlInput=row.url; isActive=row.active;">{{"MANAGEMENT.EDIT" | translate}}</button>
                            <button [disabled]="visibleInputs" (click)="delete(row.id)">{{"MANAGEMENT.DELETE" | translate}}</button>
                        </div>
                        <div *ngIf="row.actions && row.actions === 'edit'"><button
                                (click)="saveEdit(row.id)">Save</button>
                            <button (click)="row.actions = undefined; visibleInputs = false;">{{"MANAGEMENT.CANCEL" | translate}}</button>
                        </div>
                        <div *ngIf="row.actions && row.actions === 'new'"><button (click)="save()">{{"MANAGEMENT.SAVE" | translate}}</button> <button
                                (click)="cancelSave()">{{"MANAGEMENT.CANCEL" | translate}}</button></div>
                    </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

                <tr class="mat-row" *matNoDataRow>
                    <td class="mat-cell" colspan="4">{{"MANAGEMENT.NO_FILTERED_DATA" | translate}}"{{input.value}}"</td>
                </tr>
            </table>

            <mat-paginator [disabled]="visibleInputs" [pageSizeOptions]="[5, 10, 25, 100]"
                [pageSize]="5"></mat-paginator>
            <button (click)="setSaving()">{{"MANAGEMENT.ADD" | translate}}</button>
        </div>
        <div *ngIf="section === 'properties' && loggedUser.role === 'ROLE_ADMIN'" class="mat-elevation-z8 section">
            <div class="pt-4 pb-2 admin-tools">
                <table aria-hidden="true">
                    <tr>
                        <th>
                            <p class="mb-2">{{"MANAGEMENT.SCHEDULER_PURGE" | translate}}</p>
                        </th>
                        <th></th>
                        <th class="pl-2">
                            <p class="mb-2">{{"MANAGEMENT.PURGE_MAX_AGE" | translate}}</p>
                        </th>
                        <th></th>

                    </tr>
                    <tr>
                        <td><input type="text" [(ngModel)]="purgeScheduler"></td>
                        <td><button (click)="changeScheduler('DBCleanerService')">{{"MANAGEMENT.CHANGE_PURGE" | translate}}</button></td>
                        <td><input type="text" [(ngModel)]="dbCleanerDays"></td>
                        <td><button (click)="changeDbCleanerDays()">{{"MANAGEMENT.CHANGE_PURGE_DAYS" | translate}}</button></td>
                    </tr>
                </table>
                <table aria-hidden="true">
                    <tr>
                        <th>
                            <p class="mb-2">{{"MANAGEMENT.SCHEDULER" | translate}}</p>
                        </th>

                        <th>
                        </th>
                        <th class="pl-2">
                            <p class="mb-2">{{"MANAGEMENT.CS_VALIDATION" | translate}}</p>
                        </th>
                    </tr>
                    <tr>
                        <td><input type="text" [(ngModel)]="scheduler"></td>
                        <td><button (click)="changeScheduler('MessageRetrieverService')">Change</button></td>
                        <td class="pl-2">
                            <select [(ngModel)]="validationStatus" (change)="changeCommonServiceValidation()">
                                <option value=true>True</option>
                                <option value=false>False</option>
                            </select>
                        </td>
                    </tr>
                </table>
            </div>
            <div class="pt-4 pb-2 admin-tools" *ngIf="levelsForm">

                <form [formGroup]="levelsForm" class="m-0 p-0">
                    <table aria-hidden="true">
                        <tr>
                            <th>
                                <p class="mb-2">{{"MANAGEMENT.LOGGING_LEVEL" | translate}}</p>
                            </th>
                        </tr>
                        <tr>
                            <td>
                                <select *ngIf="levelsForm.controls['levelControl']" formControlName="levelControl"
                                    (change)="logLevelMethods(levelsForm.controls['levelControl'].value)">
                                    <option [value]="level" *ngFor="let level of levels">{{level}}</option>
                                </select>
                            </td>
                        </tr>
                    </table>

                </form>
            </div>

            <mat-form-field class="filter">
                <mat-label>{{"MANAGEMENT.FILTER" | translate}}</mat-label>
                <input matInput (keyup)="applyFilterProperties($event)" placeholder="" #input>
            </mat-form-field>

            <div class="tabs">
                <button class="tab" *ngFor="let type of types; let i = index;"
                    [ngClass]="{'selected-tab': type.selected}" (click)="changeType(i)">
                    <span>{{capitalize(type.name)}}</span>
                </button>
            </div>
            <table mat-table [dataSource]="dataSourceProperties" matSort class="mt-3" aria-hidden="true">

                <ng-container matColumnDef="propertyName">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> {{"MANAGEMENT.PROPERTY_NAME" | translate}} </th>
                    <td mat-cell *matCellDef="let row">
                        <div>{{row.propertyName}}</div>
                    </td>
                </ng-container>

                <ng-container matColumnDef="value">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> {{"MANAGEMENT.PROPERTY_VALUE" | translate}} </th>
                    <td mat-cell *matCellDef="let row">
                        <div *ngIf="!(row.actions && (row.actions === 'new' || row.actions === 'edit'))">{{row.value}}
                        </div>
                        <div *ngIf="row.actions && (row.actions === 'new' || row.actions === 'edit')">

                            <div *ngIf="row['propertyClass'] === 'java.lang.Boolean'; else other">
                                <select [(ngModel)]="editedProperty['value']">
                                    <option>true</option>
                                    <option>false</option>
                                </select>

                            </div>
                            <ng-template #other>
                                <input type="text" [(ngModel)]="editedProperty['value']">
                            </ng-template>
                        </div>
                    </td>
                </ng-container>

                <ng-container matColumnDef="actions">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> {{'MANAGEMENT.ACTIONS' | translate}} </th>
                    <td mat-cell *matCellDef="let row ; let i = index">
                        <div *ngIf="!(row.actions && (row.actions === 'new' || row.actions === 'edit'))"><button
                                [disabled]="visibleInputsProperties"
                                (click)="row.actions = 'edit'; setServiceEditedProperty(row);">{{"MANAGEMENT.EDIT" | translate}}</button></div>
                        <div *ngIf="row.actions && row.actions === 'edit'"><button
                                (click)="saveEditedProperty()">{{"MANAGEMENT.SAVE" | translate}}</button> <button
                                (click)="row.actions = undefined; visibleInputsProperties = false;">{{"MANAGEMENT.CANCEL" | translate}}</button>
                        </div>
                    </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="columnsProperties"></tr>
                <tr mat-row *matRowDef="let row; columns: columnsProperties;"></tr>

                <tr class="mat-row" *matNoDataRow>
                    <td class="mat-cell" colspan="4">{{"MANAGEMENT.NO_FILTERED_DATA" | translate}}"{{input.value}}"</td>
                </tr>
            </table>
            <mat-paginator [disabled]="visibleInputsProperties" [pageSizeOptions]="[5, 10, 25, 100]"
                [pageSize]="5"></mat-paginator>
        </div>
        <div *ngIf="section==='services' || section==='singleService'" #services class="section mat-elevation-z8">
            <div class="side-by-side">
                <div class="main-section"
                    [ngClass]="{'full-section': section==='singleService'&& serviceTypesLeft.length > 0, 'hidden': serviceTypesLeft.length === 0}">
                    <div *ngFor="let serviceType of serviceTypesLeft">
                        <div class="data-table">
                            <div class="mini-bluebox">
                                <div>
                                    <button
                                        [ngClass]="servicesStates.get(serviceType)?.state === 'open' ? 'non-visible' : 'action-button-white'"
                                        (click)="openListByType(serviceType)"><i class="bi bi-plus"></i></button>
                                    <button
                                        [ngClass]="servicesStates.get(serviceType)?.state === 'open' ? 'action-button-white': 'non-visible'"
                                        (click)="closeTable(serviceType)"><i class="bi bi-dash"></i></button>
                                    <span class="mini-title">{{'MANAGEMENT.SERVICE_TYPE.' +
                                        translateAttrNames(serviceType)
                                        | translate}}</span>
                                </div>
                                <input placeholder="{{'MANAGEMENT.FILTER' | translate}}" class="filter-input"
                                    *ngIf="servicesStates.get(serviceType)?.state === 'open'"
                                    (keyup)="applyFilterService($event, serviceType)" placeholder="" #input>
                            </div>
                            <div
                                [ngClass]="servicesStates.get(serviceType)?.state === 'open' ? 'table-holder': 'non-visible'">
                                <table mat-table
                                    [dataSource]="dataSourceServices.get(serviceType) ?? dataSourceProperties" matSort
                                    class="mt-3" aria-hidden="true">
                                    <ng-container [matColumnDef]="col"
                                        *ngFor="let col of servicesDataMap.get(serviceType)">
                                        <div *ngIf="col==='id'">
                                            <th mat-header-cell *matHeaderCellDef>
                                                Id
                                            </th>
                                            <td mat-cell *matCellDef="let row">
                                                {{row[col]}}
                                            </td>
                                        </div>
                                        <div *ngIf="col!=='id' && col!=='actions'">
                                            <th mat-header-cell *matHeaderCellDef>
                                                {{'MANAGEMENT.' + translateAttrNames(col) | translate}}
                                            </th>

                                            <td mat-cell *matCellDef="let row">
                                                <div
                                                    *ngIf="!(row.actions && (row.actions === 'new' || row.actions === 'edit'))">
                                                    {{row[col]}}</div>
                                                <div
                                                    *ngIf="row.actions && (row.actions === 'new' || row.actions === 'edit')">
                                                    <input type="text" [(ngModel)]="editedEntry[col]">
                                                </div>
                                            </td>
                                        </div>
                                        <div *ngIf="col==='actions'">
                                            <th mat-header-cell *matHeaderCellDef>
                                                {{'MANAGEMENT.' + translateAttrNames(col) | translate}}
                                            </th>
                                            <td mat-cell *matCellDef="let row ;">
                                                <div
                                                    *ngIf="!(row.actions && (row.actions === 'new' || row.actions === 'edit'))">
                                                    <button class="action-button" [disabled]="visibleInputsProperties"
                                                        (click)="row.actions = 'edit'; setServiceEditedEntry(row)"><i
                                                            class="bi bi-pencil-fill"></i></button>
                                                </div>
                                                <div
                                                    *ngIf="row.actions && (row.actions === 'new' || row.actions === 'edit')">
                                                    <button class="action-button"
                                                        (click)="saveServiceProperty(serviceType, editedEntry)"><i
                                                            class="bi bi-check2"></i></button> <button
                                                        class="action-button"
                                                        (click)="row.actions = undefined; visibleInputsProperties = false;"><i
                                                            class="bi bi-x"></i></button></div>
                                            </td>
                                        </div>


                                    </ng-container>
                                    <tr mat-header-row *matHeaderRowDef="servicesDataMap.get(serviceType)"></tr>
                                    <tr mat-row *matRowDef="let row; columns: servicesDataMap.get(serviceType);"></tr>
                                </table>
                                <mat-paginator [disabled]="visibleInputsProperties" [pageSizeOptions]="[5, 10, 25, 100]"
                                    [pageSize]="5"></mat-paginator>
                                <div class="but-holder" *ngIf="serviceType === 'Requirements'">
                                    <button (click)="setServiceSavingEntry(serviceType)">{{"MANAGEMENT.ADD" | translate}}</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="side-section"
                    [ngClass]="{'full-section': section==='singleService' && serviceTypesRight.length > 0, 'hidden': serviceTypesRight.length === 0}">
                    <div *ngFor="let serviceType of serviceTypesRight">
                        <div class="data-table">
                            <div class="mini-bluebox">
                                <div>
                                    <button
                                        [ngClass]="servicesStates.get(serviceType)?.state === 'open' ? 'non-visible' : 'action-button-white'"
                                        (click)="openListByType(serviceType)"><i class="bi bi-plus"></i></button>
                                    <button
                                        [ngClass]="servicesStates.get(serviceType)?.state === 'open' ? 'action-button-white': 'non-visible'"
                                        (click)="closeTable(serviceType)"><i class="bi bi-dash"></i></button>
                                    <span class="mini-title">{{'MANAGEMENT.SERVICE_TYPE.' +
                                        translateAttrNames(serviceType)
                                        | translate}}</span>
                                </div>
                                <input placeholder="{{'MANAGEMENT.FILTER' | translate}}" class="filter-input"
                                    *ngIf="servicesStates.get(serviceType)?.state === 'open'"
                                    (keyup)="applyFilterService($event, serviceType)" placeholder="" #input>
                            </div>
                            <div
                                [ngClass]="servicesStates.get(serviceType)?.state === 'open' ? 'table-holder': 'non-visible'">
                                <table mat-table
                                    [dataSource]="dataSourceServices.get(serviceType) ?? dataSourceProperties" matSort
                                    class="mt-3" aria-hidden="true">
                                    <ng-container [matColumnDef]="col"
                                        *ngFor="let col of servicesDataMap.get(serviceType)">
                                        <div *ngIf="col==='id'">
                                            <th mat-header-cell *matHeaderCellDef>
                                                Id
                                            </th>
                                            <td mat-cell *matCellDef="let row">
                                                {{row[col]}}
                                            </td>
                                        </div>
                                        <div *ngIf="col!=='id' && col!=='actions'">
                                            <th mat-header-cell *matHeaderCellDef>
                                                {{'MANAGEMENT.' + translateAttrNames(col) | translate}}
                                            </th>

                                            <td mat-cell *matCellDef="let row">
                                                <div
                                                    *ngIf="!(row.actions && (row.actions === 'new' || row.actions === 'edit')) && row[col]?.description">
                                                    {{row[col]?.id}}: {{row[col]?.description}}</div>
                                                <div
                                                    *ngIf="!(row.actions && (row.actions === 'new' || row.actions === 'edit')) && row[col].serviceName">
                                                    {{row[col]?.id}}: {{row[col]?.serviceName}}</div>
                                                <div
                                                    *ngIf="!(row.actions && (row.actions === 'new' || row.actions === 'edit')) && !row[col]?.serviceName && !row[col]?.description">
                                                    {{row[col]}}</div>
                                                <div
                                                    *ngIf="row.actions && (row.actions === 'new' || row.actions === 'edit')">
                                                    <div *ngIf="checkType(row[col], 'boolean'); else other">
                                                        <select [(ngModel)]="editedEntry[col]">
                                                            <option value=true>
                                                                true
                                                            </option>
                                                            <option value=false>
                                                                false
                                                            </option>
                                                        </select>

                                                    </div>
                                                    <ng-template #other>
                                                        <select2
                                                            [data]="dataSourceSelectData.get(getServiceTypeByAttr(col)) ?? []"
                                                            class="select2"
                                                            (update)="setSelectedOptionData($event, col)">
                                                        </select2>
                                                    </ng-template>
                                                </div>
                                            </td>
                                        </div>
                                        <div *ngIf="col==='actions'">
                                            <th mat-header-cell *matHeaderCellDef>
                                                {{'MANAGEMENT.' + translateAttrNames(col) | translate}}
                                            </th>

                                            <td mat-cell *matCellDef="let row ;">
                                                <div
                                                    *ngIf="!(row.actions && (row.actions === 'new' || row.actions === 'edit'))">
                                                    <button class="action-button" [disabled]="visibleInputsProperties"
                                                        (click)="row.actions = 'edit'; setServiceEditedEntry(row, 'select', serviceType)"><i
                                                            class="bi bi-pencil-fill"></i></button>
                                                    <button class="action-button" [disabled]="visibleInputsProperties"
                                                        (click)="deleteServiceEntry(serviceType, row.id)"><i
                                                            class="bi bi-trash-fill"></i></button>
                                                </div>
                                                <div
                                                    *ngIf="row.actions && (row.actions === 'new' || row.actions === 'edit')">
                                                    <button class="action-button"
                                                        (click)="saveServiceProperty(serviceType, editedEntry)"><i
                                                            class="bi bi-check2"></i></button> <button
                                                        class="action-button"
                                                        (click)="cancelSaveService(serviceType)"><i
                                                            class="bi bi-x"></i></button></div>
                                            </td>
                                        </div>


                                    </ng-container>
                                    <tr mat-header-row *matHeaderRowDef="servicesDataMap.get(serviceType)"></tr>
                                    <tr mat-row *matRowDef="let row; columns: servicesDataMap.get(serviceType);"></tr>
                                </table>
                                <mat-paginator [id]="'paginator-' + serviceType" [disabled]="visibleInputsProperties"
                                    [pageSizeOptions]="[5, 10, 25, 100]" [pageSize]="5"></mat-paginator>
                                <div class="but-holder">
                                    <button (click)="setServiceSavingEntry(serviceType)">{{"MANAGEMENT.ADD" | translate}}</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div *ngIf="section==='template'" class="section mat-elevation-z8">
            <mat-form-field class="filter">
                <mat-label>Filter</mat-label>
                <input matInput (keyup)="applyFilter($event)" placeholder="" #input>
            </mat-form-field>
            <table mat-table [dataSource]="dataSource" matSort aria-hidden="true">

                <ng-container matColumnDef="id">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> ID </th>
                    <td mat-cell *matCellDef="let row">
                        <div>{{row.id}}</div>
                    </td>
                </ng-container>

                <ng-container matColumnDef="service">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> {{'MANAGEMENT.REQUIREMENT' | translate}}
                    </th>
                    <td mat-cell *matCellDef="let row">
                        <div *ngIf="row.requirementId">{{row.requirementId.description}}</div>
                        <div *ngIf="row.actions && (row.actions === 'new')">
                            <select2 [data]="dataSourceSelectData.get(getServiceTypeByAttr('serviceId')) ?? []"
                                class="select2" (update)="setSelectedOptionData($event, 'serviceId')">
                            </select2>
                        </div>
                    </td>
                </ng-container>

                <ng-container matColumnDef="templateName">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> {{"MANAGEMENT.NAME" | translate}} </th>
                    <td mat-cell *matCellDef="let row">
                        <div>{{row.templateName}}</div>
                    </td>
                </ng-container>

                <ng-container matColumnDef="actions">
                    <th mat-header-cell *matHeaderCellDef>
                        {{'MANAGEMENT.ACTIONS' | translate}}
                    </th>
                    <td mat-cell *matCellDef="let row ; let i = index;">
                        <div *ngIf="row.actions && (row.actions === 'new' || row.actions === 'edit')">
                            <input type="file" (change)="changeTemplate($event)">
                        </div>
                        <div *ngIf="!(row.actions && (row.actions === 'new' || row.actions === 'edit'))">
                            <button class="action-button" [disabled]="visibleInputsProperties"
                                (click)="row.actions = 'edit'; setTemplateData(i)"><i
                                    class="bi bi-pencil-fill"></i></button>
                        </div>
                        <div *ngIf="row.actions && (row.actions === 'edit' || row.actions === 'new')">
                            <button *ngIf="row.actions === 'edit'" class="action-button" (click)="updateTemplate()"><i
                                    class="bi bi-check2"></i></button>
                            <button *ngIf="row.actions === 'new'" class="action-button" (click)="saveTemplate()"><i
                                    class="bi bi-check2"></i></button>
                            <button class="action-button"
                                (click)="row.actions = undefined; visibleInputsProperties = false;"><i
                                    class="bi bi-x"></i>
                            </button>
                        </div>
                    </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="columnsTemplates"></tr>
                <tr mat-row *matRowDef="let row; columns: columnsTemplates;"></tr>

                <tr class="mat-row" *matNoDataRow>
                    <td class="mat-cell" colspan="4">{{"MANAGEMENT.NO_FILTERED_DATA" | translate}}"{{input.value}}"</td>
                </tr>
            </table>

            <mat-paginator [disabled]="visibleInputs" [pageSizeOptions]="[5, 10, 25, 100]"
                [pageSize]="5"></mat-paginator>
            <button (click)="setNewTemplateData()">{{"MANAGEMENT.ADD" | translate}}</button>
        </div>
        <div *ngIf="section==='registry'" class="section mat-elevation-z8 p-3">
            <app-registry></app-registry>
        </div>
    </div>

</div>
<div class="custom-alert" *ngIf="popUp.show">
    <p class="title-alert">{{popUp.title}}</p>
    <p class="message-alert">{{popUp.message}}</p>
</div>